<template>
  <v-snackbar
      v-model="item.active"
  >
    {{ item.content }}

    <template v-slot:action="{ attrs }">
      <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="close"
      >
        閉じる
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {store} from "@/store";
export default {
  name: "SnackBar",
  data(){
    return {
      item: store.state.snackbar
    }
  },
  methods: {
    close(){
      store.closeSnackBar()
    }
  }
}
</script>

<style scoped>

</style>
